const initialState={
    show : false,
}

export const LoaderReducer = (state = initialState, action: { type: string, payload: boolean }) => {
	switch (action.type) {
		case 'SHOW_LOADER':
			return {  show: true };
		case 'HIDE_LOADER':
			return { show: false };
		default:
			return state;
	}
};




